// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"s2-z","displaySixCardTiles":"t2-z"};